export const LOADING_FOR_API_CLICK = "LOADING_FOR_API_CLICK"
export const LOADING_FOR_API_CLICK_CONFLICT = "LOADING_FOR_API_CLICK_CONFLICT"
